import { FormSection } from "@/components/persons/person-form/FormSection";
import type { PersonForm } from "@/components/persons/person-form/types";
import { FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";

export function NotesSection({ form }: { form: PersonForm }) {
  return (
    <FormSection title="Notes">
      <FormField
        control={form.control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Textarea
                placeholder="General notes about this person"
                className="min-h-[80px]"
                {...field}
                value={field.value ?? ""}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </FormSection>
  );
}
